import React, { useState, useEffect } from 'react';
import { Alert, Button } from 'antd';
import useAuth from 'core/hooks/useAuth';
import { api } from 'react-structure-admin';
import generateUUID from 'util/functions/generateUUID';

const FinancialEntryAccountantAlert = () => {
  const { accountantId } = useAuth();
  const [messages, setMessages] = useState([]);
  const [showDetail, setShowDetail] = useState(false);

  const handleCheck = () => {
    if (!accountantId) {
      return;
    }

    api
      .get('accountants', `${accountantId}/validate-all-parameters`)
      .then(({ errors }) => {
        if (Array.isArray(errors)) {
          setMessages(errors.map((c) => c.message));
        }
      });
  };

  useEffect(() => {
    handleCheck();
  }, []);

  if (!Array.isArray(messages) || messages.length === 0) {
    return null;
  }

  return (
    <Alert
      className="gx-mb-1"
      showIcon
      message="Pendências na configuração da contabilidade"
      description={
        <div>
          {showDetail ? (
            <div className="gx-mt-2">
              {messages.map((c, index) => (
                <div key={generateUUID()}>
                  <span>
                    <strong>{`${index + 1}`}</strong>
                    <span>{` - ${c}`}</span>
                  </span>
                </div>
              ))}
              <div>Favor contactar a contabilidade.</div>
            </div>
          ) : (
            <Button size="small" onClick={() => setShowDetail(true)}>
              Detalhes
            </Button>
          )}
        </div>
      }
      type="warning"
      closable
    />
  );
};

export default FinancialEntryAccountantAlert;
